import { usePage } from "@inertiajs/react"
import { Link } from "@inertiajs/react"
import { AudioLines } from "lucide-react"

interface SharedProps {
  activeTranscriptions: number
}

export function StatusIndicators() {
  const { activeTranscriptions } = usePage<{ props: SharedProps }>().props as unknown as SharedProps

  if (activeTranscriptions === 0) return null

  return (
    <div className="flex items-center gap-2">
      {activeTranscriptions > 0 && (
        <Link
          href="/transcriptions"
          className="flex items-center gap-1.5 rounded-full bg-primary/10 px-3 py-1 text-xs font-medium text-primary transition-colors hover:bg-primary/20"
          data-testid="transcription-indicator"
        >
          <AudioLines className="h-3.5 w-3.5" />
          {activeTranscriptions} transcribing
        </Link>
      )}
    </div>
  )
}
